module.exports = __webpack_public_path__ + "static/image/font/pc/bmhannapro.gif?437be467";